<template>
    <div class="pl-4 pt-3 row nav-padding">
        <el-form class="w-50"
                 label-width="130px"
                 label-position="top">

            <div class="row">
                <div class="col-9">
                    <el-form ref="number-lookup"
                            label-position="top"
                            :model="number_lookup"
                            :rules="rules_number_lookup"
                            @submit.prevent.native="lookupPhoneNumber">
                        <el-form-item label="Enter a phone number:">
                            <el-input class="width-200 p-0"
                                    placeholder="+18185005050"
                                    v-model="number_lookup.phone_number"
                                    @input="preValidateForm('number-lookup')">
                            </el-input>
                            <el-button type="success"
                                    class="p-x-md"
                                    :loading="loading_lookup_btn"
                                    :disabled="!validated || current_company == null"
                                    @click="lookupPhoneNumber">
                                Lookup
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

            <div class="row"
             v-if="has_result">
            <div class="col-md-6">
                <strong>Formatted response:</strong>
                <p class="text-danger mt-2"
                   v-if="lookup_result.error">
                    <strong>Error!</strong>
                </p>
                <p class="mt-2 mb-2"
                   v-if="lookup_result.sid">
                    <strong>Phone Number:</strong>
                    {{ lookup_result.sid | fixPhone('E164', true) }}
                </p>
                <p class="mb-2"
                   v-if="lookup_result.data">
                    <strong>National Format:</strong>
                    {{ lookup_result.sid | fixPhone('NATIONAL') }}
                </p>
                <p class="mb-2"
                   v-if="lookup_result.data">
                    <strong>Carrier Name:</strong>
                    {{ lookup_result.carrier }}
                </p>
                <p class="mb-2"
                   v-if="lookup_result.data">
                    <strong>Line Type:</strong>
                    {{ lookup_result.line_type | fixLrnType | fixName }}
                </p>
                <p class="mb-2"
                   v-if="lookup_result.data">
                    <strong>City:</strong>
                    {{ lookup_result.cnam_city }}
                </p>
                <p class="mb-2"
                   v-if="lookup_result.data">
                    <strong>State:</strong>
                    {{ lookup_result.cnam_state }}
                </p>
                <p class="mb-2"
                   v-if="lookup_result.data">
                    <strong>Country:</strong>
                    {{ lookup_result.cnam_country }}
                </p>
            </div>
            <div class="col-md-6">
                <strong>Response body:</strong>
                <pre v-highlightjs><code class="json">{{ lookup_result }}</code></pre>
            </div>
        </div>

        </el-form>
    </div>
</template>

<script>
import auth from '../../auth'
import {form_validation_mixin, validator_mixin} from '../../mixins'

export default {
    mixins: [
        validator_mixin,
        form_validation_mixin
    ],

    data() {
        return {
            env: null,
            auth: auth,
            rules_number_lookup: {
                phone_number: {
                    validator: this.phoneValidator,
                    trigger: 'blur'
                }
            },
            number_lookup: {
                phone_number: null
            },
            loading_lookup_btn: false,
            lookup_result: {},
            has_result: false,
            company_id: null,
            current_company: null
        }
    },

    methods: {
        lookupPhoneNumber() {
            this.has_result = false
            if (this.validateForm('number-lookup') == true) {
                this.loading_lookup_btn = true
                this.lookup_result = {}
                let data = {
                    'phone_number': this.number_lookup.phone_number,
                    'api_token': this.current_company.form_capture_token,
                    'should_log': true,
                    'admin_id': this.auth.user.profile.id
                }
                axios.post('/api/v1/webhook/lookup', data).then(res => {
                    this.loading_lookup_btn = false
                    this.lookup_result = res.data
                    this.has_result = true
                    this.resetNumberLookup()
                }).catch(err => {
                    console.log(err)
                    this.lookup_result = err.response.data
                    this.has_result = true
                    this.loading_lookup_btn = false
                    this.resetNumberLookup()
                })
            }

            return false
        },

        resetNumberLookup() {
            this.number_lookup.phone_number = null
            this.validated = false
        },

        // get the copmany info
        getDemoCompanyInfo() {
            const demo_company_id = localStorage.getItem('demo_company_id')
            axios.get('/api/admin/company', {
                params: {
                    id: demo_company_id
                }
            }).then(res => {
                if (res.data[0] !== undefined) {
                    this.current_company = res.data[0]
                }
            })
        },

    },

    mounted() {
        this.getDemoCompanyInfo()
    }
}
</script>
